export type TutorLessonConfirmationTranslateFn = (
  key: string,
  defaultValue: string,
) => string;

function getHttpStatus(err: unknown): number | undefined {
  if (err && typeof err === 'object' && 'response' in err) {
    const response = (err as { response?: { status?: number } }).response;
    return response?.status;
  }
  return undefined;
}

export function getTutorLessonConfirmationErrorMessage(
  err: unknown,
  t: TutorLessonConfirmationTranslateFn,
): string {
  const status = getHttpStatus(err);
  if (status === 404) {
    return t(
      'userTutorBookings.lessonConfirmation.errors.notFound',
      'This booking could not be found. Refresh and try again.',
    );
  }
  if (status === 400) {
    return t(
      'userTutorBookings.lessonConfirmation.errors.notConfirmable',
      'Attendance can only be confirmed for confirmed lessons.',
    );
  }
  return t(
    'userTutorBookings.lessonConfirmation.errors.generic',
    'Could not confirm attendance. Please try again.',
  );
}
